var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { set } from "lodash";
import FullModal from "@irati/ui/src/FullModal";
import Loading from "@irati/ui/src/Loading";
import { injectIntl } from "@irati/utils/lang";
import { waitPromise } from "@irati/utils/promise";
import stepsStory, { anyStoriesOpen } from "@irati/utils/modalStory";
import companyBenefitsService from "@irati/deals/services/companyBenefits";
import dealPackageService from "@irati/deals/services/package";
import transformLocale from "@irati/utils/lang/helpers/transformLocale";
import Card from "./Card";
import Description from "./Description";
import Instructions from "./Instructions";
import SuccessStep from "./SuccessStep";
export var CARD = "CARD";
export var DESCRIPTION = "DESCRIPTION";
export var INSTRUCTIONS = "INSTRUCTIONS";
export var SUCCESS = "SUCCESS";
var steps = [CARD, DESCRIPTION, INSTRUCTIONS, SUCCESS];
var EMPTY_COMPANY_BENEFIT = function () { return ({
    header: null,
    savings: {
        userSavings: {
            value: null,
            type: null,
            header: null
        }
    },
    cardImage: null,
    description: null,
    importantInfo: [],
    redemptionInstructions: "- ",
    contactInfo: null
}); };
var CompanyBenefitsPopup = /** @class */ (function (_super) {
    __extends(CompanyBenefitsPopup, _super);
    function CompanyBenefitsPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            dealPackageService.getCurrentPackage().then(function (_a) {
                var locale = _a.locale;
                _this.setState({ locale: transformLocale(locale) });
            });
        };
        _this.setBenefit = function (benefit) {
            var load = companyBenefitsService.getForAdmin(benefit.uuid).then(function (fullBenefit) {
                _this.setState({ benefit: fullBenefit, edit: true });
            });
            _this.setState({ load: load });
        };
        _this.setEdit = function (edit) {
            _this.setState({ edit: edit });
        };
        _this.show = function (stepToShow) {
            if (stepToShow === void 0) { stepToShow = CARD; }
            _this.setState(function (_a) {
                var show = _a.show, benefit = _a.benefit;
                return ({
                    show: stepsStory(steps, stepToShow),
                    benefit: anyStoriesOpen(show) ? benefit : EMPTY_COMPANY_BENEFIT()
                });
            });
        };
        _this.hide = function () { return _this.setState({ show: stepsStory(steps, null) }); };
        _this.onChange = function (property, value) {
            var benefit = _this.state.benefit;
            set(benefit, property, value);
            _this.setState(function (prevState) { return ({
                benefit: __assign(__assign({}, prevState.benefit), benefit)
            }); });
        };
        _this.handleSubmit = function () {
            var _a = _this.state, benefit = _a.benefit, edit = _a.edit, locale = _a.locale;
            var _b = _this.props.onChange, onChange = _b === void 0 ? function () { } : _b;
            var localBenefit = __assign(__assign({}, benefit), { locale: locale });
            if (edit) {
                return companyBenefitsService.update(benefit.uuid, localBenefit).then(function (updatedBenefit) {
                    _this.setState({ show: stepsStory(steps, SUCCESS), edit: false });
                    onChange(updatedBenefit, "edit");
                });
            }
            return companyBenefitsService.create(localBenefit).then(function (newBenefit) {
                _this.setState({ show: stepsStory(steps, SUCCESS), edit: false });
                return waitPromise(2000).then(function () { return onChange(newBenefit); });
            });
        };
        _this.state = {
            show: stepsStory(steps, null),
            benefit: _this.props.benefit || EMPTY_COMPANY_BENEFIT(),
            edit: false,
            imageEdited: false
        };
        return _this;
    }
    CompanyBenefitsPopup.prototype.render = function () {
        var _a = this.state, show = _a.show, benefit = _a.benefit, load = _a.load;
        var hideBannerImageUpload = this.props.hideBannerImageUpload;
        if (!benefit) {
            return null;
        }
        return (React.createElement(FullModal, { show: anyStoriesOpen(show), onHide: this.hide },
            React.createElement(Loading, { load: load },
                React.createElement(Card, { show: show[CARD], selectStep: this.show, onChange: this.onChange, benefit: benefit, hideBannerImageUpload: hideBannerImageUpload })),
            React.createElement(Description, { show: show[DESCRIPTION], selectStep: this.show, onChange: this.onChange, benefit: benefit }),
            React.createElement(Instructions, { show: show[INSTRUCTIONS], selectStep: this.show, onChange: this.onChange, onSubmit: this.handleSubmit, benefit: benefit }),
            React.createElement(SuccessStep, { show: show[SUCCESS], onHide: this.hide })));
    };
    return CompanyBenefitsPopup;
}(Component));
export default injectIntl(CompanyBenefitsPopup, { withRef: true });
